import React, { Component } from "react";
import PropTypes from "prop-types";

import { Translate } from "react-redux-i18n";

import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import "../../../styles/components/utils/components/ComponentSelector.scss";

class ComponentSelector extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    // checks the name of the second tab everytime it initializes if the scond tab its called label_history its because View insights was clicked
    if (this.props.tabs[1]?.title === "label_history") {
      this.state = {
        selectedTab: props.selectedTab || 1,
      };
    } else {
      this.state = {
        selectedTab: props.selectedTab || 0,
      };
    }
    this.selectTab = this.selectTab.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  selectTab(e, tabIndex) {
    this.safeSetState(
      {
        selectedTab: tabIndex,
      },
      () => {
        if (this.props.updateSelectedTab)
          this.props.updateSelectedTab(e, tabIndex);
        if (this.props.changeTab) {
          this.props.changeTab();
        }
      }
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    if (this.props.hasOwnProperty("renderTabs"))
      return (
        <Tabs
          id="componentSelector"
          transition={false}
          activeKey={this.state.selectedTab}
          onSelect={(k, e) => this.selectTab(e, k)}
        >
          {this.props.tabs.map((tab, k) => {
            return (
              <Tab key={k} eventKey={k} title={tab.title}>
                {this.props.tabs[this.state.selectedTab].component}
              </Tab>
            );
          })}
        </Tabs>
      );
    else
      return (
        <>
          <div id="header">
            {this.props.tabs.map((tab, k) => {
              return (
                <h3
                  key={tab.title}
                  className={this.state.selectedTab === k ? "selected" : ""}
                  onClick={(e) => this.selectTab(e, k)}
                >
                  <Translate value={tab.title} />
                </h3>
              );
            })}
          </div>
          {this.props.tabs[this.state.selectedTab].component}
        </>
      );
  }
}

ComponentSelector.propTypes = {
  selectedTab: PropTypes.number,
  updateSelectedTab: PropTypes.func,
  tabs: PropTypes.array.isRequired,
};

export default ComponentSelector;
